module.exports = __webpack_public_path__ + "static/media/map2.38fd28dc.webp";